document.addEventListener("DOMContentLoaded", function() {
    var btnBurger = document.querySelector('#mobile-toggle');
    var mainMenu = document.querySelector('.navigation-main');
    var mobileLinks = document.querySelectorAll('#mobile-menu a');
    var header = document.querySelector('.header');
    var body = document.body;
    
    btnBurger.addEventListener('click', function() {
        mainMenu.classList.toggle('open');
        header.classList.toggle('open');
        body.classList.toggle('no-scroll');
    });

    mobileLinks.forEach(function(link) {
        link.addEventListener('click', function() {
            body.classList.toggle('no-scroll');
            if (mainMenu.classList.contains('open')) {
            mainMenu.classList.remove('open');
            }
            if (header.classList.contains('open')) {
            header.classList.remove('open');
            }
        });
    });

    window.addEventListener('resize', function() {
        if (window.innerWidth >= 1366) {
            if (mainMenu.classList.contains('open')) {
                mainMenu.classList.remove('open');
            }
            if (header.classList.contains('open')) {
                header.classList.remove('open');
            }
        }
    });

    window.addEventListener('scroll', function () {
        if (window.scrollY > 20) {
            mainMenu.classList.add('scrolled');
            header.classList.add('scrolled');
        } else {
            mainMenu.classList.remove('scrolled');
            header.classList.remove('scrolled');
        }
    });
});